import * as React from 'react';
import { ca } from '@cian/analytics';
import { mapSectionToCategory } from '../mappers/mapSectionToCategory';

export interface IChatsCounterProps {
  baseUrl: string | undefined;
  notificationsCount: number | null;
  section?: string | null;
}

export class ChatsCounter extends React.Component<IChatsCounterProps, {}> {
  public render() {
    const { baseUrl, notificationsCount } = this.props;

    return (
      <a className="c-header__bottom-link" href={`${baseUrl}/dialogs/`} target="_blank" onClick={this.handleClick}>
        <span className="c-header__main-nav-item_messages-icon"></span>Сообщения
        {Number(notificationsCount) > 0 && (
          <span className="c-header__main-nav-item_messages-number">{notificationsCount}</span>
        )}
      </a>
    );
  }

  private handleClick = () => {
    ca('event', {
      name: 'oldevent',
      category: mapSectionToCategory(this.props.section),
      action: 'click',
      label: 'messages',
    });
  };
}
